import Axios from "axios";
import { 
    SET_HRM_PAYMENT_REASONS_LIST, 
    UNSET_HRM_PAYMENT_REASONS_LIST 
} from "@/store/mutation-types";
import {
    getHrmPaymentReasonList,
} from "@/store/api";

// initial state
const state = {
    getHrmPaymentReasonList: [],
}

const getters = {
    getHrmPaymentReasonList(state){
        return state.getHrmPaymentReasonList;
    },
}

const mutations = {
    [SET_HRM_PAYMENT_REASONS_LIST](state, data) {
        state.getHrmPaymentReasonList = data;
    },
    [UNSET_HRM_PAYMENT_REASONS_LIST](state) {
        state.getHrmPaymentReasonList = [];
    },
}

const actions = {
    getHrmPaymentReasonList({ commit }, params = {}) {
        return new Promise((resolve, reject) => {
            Axios.get(getHrmPaymentReasonList, { params })
                .then((response) => {
                    commit(SET_HRM_PAYMENT_REASONS_LIST, response.data.data || []);
                    resolve(response.data.data);
                })
                .catch((error) => {
                    commit(UNSET_HRM_PAYMENT_REASONS_LIST);
                    reject(error);
                })
        });
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}
